import React, { useEffect, useState } from "react";
import { Col, Modal, Spinner, Tab, TabContent, Tabs } from "react-bootstrap";
import { IconButton } from "@mui/material";
import { StatusCard } from "views/authenticated/styled";
import { handleBgColor, swedishIt } from "../../providers/StylingFunc";
import { getWorkerOrderInfo } from "Services/Api";
import { WorkOrderData } from "DTO/userWorkOrderListDto";
import { Sect } from "pandora/styled";
import { turquoise } from "resources/newColors";

import DisplayLogs from "../LogsDisplay";
import DisplayFiles from "../FilesDisplay";
import DisplayImages from "../ImagesDisplay";
import MapGl from "../Map/MapGl";
import { veryLightGrey } from "resources/newColors";
import { imageData } from "DTO/userWorkOrderListDto";
import CloseIcon from "@mui/icons-material/Close";
import { CaseLogType } from "types";
import { MapModal } from "./MapModal";
import LeaseInfo from "components/LeaseInfo";
import { useCtx } from "context/SessionDataContext";
import ImageSlider from "components/ImageSlider";
import Alert from "components/Alert";

type Props = {
  workorder: WorkOrderData;
  show: boolean;
  onHide: () => void;
};
export function CaseModal(props: Readonly<Props>) {
  const [activeCaseData, setActiveCaseData] = useState<WorkOrderData>();
  const [loading, setLoading] = useState(true);
  const [loadingTab, setLoadingTab] = useState(true);
  const [key, setKey] = useState("lease");

  const [viewport, setViewport] = useState({
    latitude: 59.334591,
    longitude: 18.06324,
    zoom: 8,
    width: "100%",
    height: "45vh",
    margin: "auto",
  });
  const [selectedCaseId, setSelectedCaseId] = useState<WorkOrderData>();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [imageIndex, setImageIndex] = React.useState(0);
  const [selectedUserImage, setSelectedUserImage] = useState<
    imageData[] | []
  >();
  const [selectedUserFiles, setSelectedUserFiles] = useState<
    string[] | undefined
  >();
  const [showError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [caseLogs, setCaseLogs] = useState<Array<CaseLogType>>([]);
  const [mapPopUp, setMapPopUp] = useState(false);
  const [networkCoords, setNetworkCoords] = useState([]);
  const [networkImages, setNetworkImages] = useState([]);
  const [polygonFromGeoJson, setPolygonFromGeoJson] = useState("");
  const [polygonFromCaseLocation, setPolygonFromCaseLocation] = useState<any>();

  const [show, setShow] = useState(false);
  const { changeWorkOrderStatus, setCurrentWorkOrder } = useCtx();

  useEffect(() => {
    setLoadingTab(true);
    setSelectedUserData();
  }, [key, props.workorder]);
  useEffect(() => {
    const newViewport = {
      ...viewport,
      latitude: props.workorder?.Center?.WGS84[0][0] ?? 59.334591,
      longitude: props.workorder?.Center?.WGS84[0][1] ?? 18.06324,
      zoom: 17,
    };
    setViewport(newViewport);

    setPolygonFromCaseLocation(props.workorder?.Geometry);
    if (props.workorder?.network_coords) {
      setNetworkCoords(props.workorder?.network_coords);
    }
    if (props.workorder?.network_urls) {
      setNetworkImages(props.workorder?.network_urls);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.workorder]);

  const setSelectedUserData = async () => {
    //TODO FIX THIS!!
    setCaseLogs([]);
    setSelectedUserImage([]);
    setSelectedUserFiles(undefined);

    try {
      const caseData = await getWorkerOrderInfo(
        props.workorder._id,
        props.workorder.WOCaseId
      );
      if (caseData) setActiveCaseData(caseData.Data);
      let allCaseLogs: Array<CaseLogType> = caseData ? caseData.Data.Logs : [];
      setCaseLogs(allCaseLogs);

      const newViewport = {
        ...viewport,
        latitude: caseData.Data.Center.WGS84[0][0],
        longitude: caseData.Data.Center.WGS84[0][1],
        zoom: 17,
      };
      setViewport(newViewport);

      if (caseData.Data.Document) {
        setSelectedUserFiles(caseData.Data.Document);
      } else {
        setSelectedUserFiles(undefined);
      }
      if (caseData.Data.ImageData.length) {
        setSelectedUserImage(caseData.Data.ImageData);
      } else {
        setSelectedUserImage([]);
      }
      setLoadingTab(false);
      setLoading(false);
    } catch (e: any) {
      if (e?.response?.status === 401) {
        localStorage.removeItem("token");
      }
      setSelectedUserImage([]);
      setSelectedUserFiles(undefined);
      setLoadingTab(false);
      setLoading(false);
    }
  };

  return (
    <>
      {activeCaseData && (
        <Modal
          show={props.show}
          onHide={props.onHide}
          animation
          scrollable
          backdrop
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          {...props}
        >
          <Alert
            setError={setError}
            setErrorMessage={setErrorMessage}
            showError={showError}
            errorMessage={errorMessage}
          />
          <ImageSlider
            modalIsOpen={modalIsOpen}
            closeModal={() => setIsOpen(false)}
            imageIndex={imageIndex}
            selectedUserImage={selectedUserImage}
          />
          {loading ? (
            <div style={{ paddingLeft: "50%" }}>
              <Spinner
                style={{ float: "left" }}
                animation="border"
                role="status"
              ></Spinner>
            </div>
          ) : (
            <>
              <Modal.Header
                style={{
                  display: "flex",
                }}
              >
                <Modal.Title
                  style={{ flex: 1 }}
                  id="contained-modal-title-vcenter"
                >
                  <div>
                    <Sect
                      css={`
                        color: ${turquoise};
                        margin-right: 5px;
                        width: auto;
                      `}
                    >
                      #
                    </Sect>
                    {props.workorder.WOCaseId}
                  </div>
                </Modal.Title>
                <StatusCard
                  css={`
                    text-align: center;
                    right: 0px;
                    background-color: ${handleBgColor(activeCaseData.Status)};
                    self-align: right;
                  `}
                >
                  {swedishIt(activeCaseData.Status, activeCaseData.InquiryType)}
                </StatusCard>
                <IconButton onClick={props.onHide}>
                  <CloseIcon />
                </IconButton>
              </Modal.Header>
              <Modal.Body style={{ height: "550px", overflowY: "auto" }}>
                <Tabs
                  activeKey={key}
                  onSelect={(k) => {
                    if (k === "lease" && key !== "lease") {
                      setSelectedUserData();
                    }
                    setKey(k);
                  }}
                  style={{
                    width: "100%",
                    display: "flex",
                    marginTop: 5,
                  }}
                >
                  <Tab eventKey="lease" title="Karta">
                    <TabContent
                      style={{
                        borderTop: `1px solid ${veryLightGrey}`,
                      }}
                    >
                      <Col style={{ fontSize: "14px" }}>
                        <LeaseInfo
                          {...props.workorder}
                          onChangeWorkOrderStatus={changeWorkOrderStatus}
                          updateLeaseInfo={(wo: WorkOrderData) =>
                            setCurrentWorkOrder(wo)
                          }
                        />
                        <div>
                          <div>
                            {show && (
                              <MapModal
                                show={setShow}
                                setShow={() => setShow(false)}
                                viewport={viewport}
                                setViewport={setViewport}
                                polygonFromCaseLocation={
                                  polygonFromCaseLocation
                                }
                                workOrder={props.workorder}
                                networkCoords={networkCoords}
                                networkImages={networkImages}
                                openImageModal={(index: number) => {
                                  setIsOpen(true);
                                  setImageIndex(index);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            border: "1px solid #eee",
                            margin: "30px 0",
                          }}
                        >
                          {!loadingTab && viewport && key === "lease" ? (
                            <MapGl
                              viewport={viewport}
                              setViewport={setViewport}
                              polygonFromCaseLocation={polygonFromCaseLocation}
                              workOrder={props.workorder}
                              networkCoords={networkCoords}
                              networkImages={networkImages}
                              showBigMap={setShow}
                              show={show}
                              openImageModal={(index: number) => {
                                setIsOpen(true);
                                setImageIndex(index);
                              }}
                            />
                          ) : (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ minHeight: "250px" }}
                            >
                              {" "}
                              <Spinner
                                style={{ margin: "auto" }}
                                variant="dark"
                                animation="border"
                                role="status"
                              ></Spinner>{" "}
                            </div>
                          )}
                        </div>
                      </Col>
                    </TabContent>
                  </Tab>
                  <Tab eventKey="images" title="Bilder">
                    <TabContent
                      style={{
                        borderTop: `1px solid ${veryLightGrey}`,
                      }}
                    >
                      <DisplayImages
                        setIsOpen={setIsOpen}
                        setImageIndex={setImageIndex}
                        imageProps={selectedUserImage}
                        setError={setError}
                        setErrorMessage={setErrorMessage}
                      />
                    </TabContent>
                  </Tab>
                  <Tab eventKey="files" title="Filer">
                    <TabContent
                      style={{
                        borderTop: `1px solid ${veryLightGrey}`,
                      }}
                    >
                      {
                        <DisplayFiles
                          selectedUserFiles={selectedUserFiles}
                          setError={setError}
                          setErrorMessage={setErrorMessage}
                        />
                      }
                    </TabContent>
                  </Tab>
                  <Tab eventKey="log" title="Logg">
                    <TabContent
                      style={{
                        borderTop: `1px solid ${veryLightGrey}`,
                        overflowX: "auto",
                      }}
                    >
                      <DisplayLogs caseLogs={caseLogs} isModal={true} />
                    </TabContent>
                  </Tab>
                </Tabs>
              </Modal.Body>
            </>
          )}
        </Modal>
      )}
    </>
  );
}
